module.exports = __webpack_public_path__ + "static/media/Honda_2.645709df.jpg";